<template>
  <div class="settings-section">
    <h4 class="text-h4 q-mt-none q-mb-lg">
      {{ $t('userPanel.settings.aboutPhotographerTitle') }}
    </h4>

    <div class="description-card description-card-secondary q-pa-md q-mb-lg">
      <div class="row items-center">
        <div class="col-auto q-mr-md">
          <q-icon name="camera_alt" color="secondary" size="24px" />
        </div>
        <div class="col">
          {{ $t('userPanel.settings.aboutPhotographerInfo') }}
        </div>
      </div>
    </div>

    <q-form
      class="photographer-profile-form"
      @submit.prevent="submitForm"
    >
      <div class="form-content">
        <q-card flat bordered class="profile-settings-card q-pa-md">
          <div class="row q-mb-md">
            <div class="col-12">
              <q-input
                v-model="form.headline"
                :label="$t('userPanel.settings.landingHeadline')"
                maxlength="60"
                :rules="[requiredRule]"
                hide-bottom-space
                dense
                filled
              />
            </div>
          </div>

          <div class="row q-mb-md">
            <div class="col-12">
              <q-input
                v-model="form.bio"
                :label="$t('userPanel.settings.landingBio')"
                type="textarea"
                maxlength="250"
                autogrow
                filled
                counter
                :rules="[requiredRule]"
                hide-bottom-space
                dense
              />
            </div>
          </div>

          <div class="row q-mb-md">
            <div class="col-12">
              <q-input
                v-model="form.instagram"
                :label="$t('userPanel.settings.landingInstagram')"
                :rules="[validateInstagramRule]"
                prefix="https://instagram.com/"
                dense
                filled
                hide-bottom-space
              />
            </div>
          </div>

          <div class="row q-mb-md">
            <div class="col-12 q-mb-md">
              <q-toggle
                v-model="form.openForBookings"
                :label="$t('userPanel.settings.openForBookings')"
                color="primary"
                :true-value="true"
                :false-value="false"
              />
              <div class="text-caption text-grey-7 q-mt-xs q-ml-sm">
                {{ form.openForBookings 
                  ? $t('userPanel.settings.acceptingBookings') 
                  : $t('userPanel.settings.notAcceptingBookings') 
                }}
              </div>
            </div>

            <div v-if="form.openForBookings" class="col-12">
              <q-input
                v-model="form.region"
                :label="$t('userPanel.settings.landingRegion')"
                :rules="form.openForBookings ? [requiredRule] : []"
                dense
                autogrow
                filled
                maxlength="80"
                counter
                stack-label
                hide-bottom-space
              />
            </div>
          </div>

          <div class="row justify-center">
            <q-btn
              type="submit"
              color="primary"
              :label="$t('userPanel.settings.saveAndCreateLanding')"
              :loading="loading"
              unelevated
              rounded
              class="q-px-md"
            />
          </div>
        </q-card>
      </div>
    </q-form>
  </div>
</template>

<script>
export default {
  name: 'SettingsCardProfile',
  props: {
    user: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    initialFormData: {
      type: Object,
      required: true,
    },
    requiredRule: {
      type: Function,
      required: true,
    },
    validateInstagramRule: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.initialFormData },
    };
  },
  watch: {
    initialFormData: {
      handler(newVal) {
        this.form = { ...newVal };
      },
      deep: true,
    },
  },
  methods: {
    submitForm() {
      this.$emit('save', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-section {
  @extend .settings-section;
}
.description-card {
  @extend .description-card;
  &-secondary {
    border-left: 4px solid $secondary;
  }
  &-transparent-centered {
    max-width: 400px;
    margin: 0 auto;
  }
}
.photographer-profile-form {
  max-width: 450px;
  margin: 0 auto;
}
.profile-settings-card {
  border-radius: 8px;
  background-color: #f4f4f4;
}
</style>
